var a={avatar:"lds-avatar",sm:"lds-avatar--sm",xl:"lds-avatar--xl",avatarText:"lds-avatar--avatar-text",error:"lds-avatar--error"};export{a as default};
